<template>
  <div>
    <div class="jxfw">
      <div class="left_box">
        <div class="hyh">
          <div>
            <img class="dui" src="../../assets/indexImg/dui.png" alt="安徽继续教育网" />
          </div>
          <div style="margin-left: 20px;">
            <div class="y1"><span style="color: #4076f6;">01</span> 汇聚行业精英，打造顶尖教学团队​</div>
            <div class="y2">
              平台广纳各领域实力派讲师，他们拥有深厚学术背景与丰富实践经验。无论是复杂理论，还是实操技巧，都能凭借精湛教学方法，让你轻松领悟，快速掌握专业技能，稳步实现能力进阶。
            </div>
          </div>
        </div>

        <div class="hyh">
          <div>
            <img class="dui" src="../../assets/indexImg/dui.png" alt="安徽继续教育网" />
          </div>
          <div style="margin-left: 20px;">
            <div class="y1"><span style="color: #4076f6;">02</span> 高清录制，铸就精品课程内容​</div>
            <div class="y2">
              借助专业级录课室与先进高清设备，我们对每节课程进行精雕细琢。从高清画面呈现到声音的精准捕捉，不放过任何一个细节。致力于为你营造沉浸式学习氛围，带来远超传统线上课的高品质学习体验。
            </div>
          </div>
        </div>

        <div class="hyh">
          <div>
            <img class="dui" src="../../assets/indexImg/dui.png" alt="安徽继续教育网" />
          </div>
          <div style="margin-left: 20px;">
            <div class="y1"><span style="color: #4076f6;">03</span> 丰富资源库，满足多样学习需求​</div>
            <div class="y2">
              平台构建了庞大且多元的课程资源库，覆盖职业技能、兴趣爱好、学术知识等众多领域。无论你是想提升职场竞争力，还是培养个人兴趣，都能在这里找到合适课程，随时随地开启自我提升之旅。
            </div>
          </div>
        </div>
      </div>

      <div class="right_box"> 
          <img src="../../assets/indexImg/video_icon.png" alt="安徽继续教育网">
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.jxfw {
  width: 1400px;
  position: relative;
  z-index: 2;
  margin-top: 68px;
  display: flex;
  justify-content: space-between;
  .left_box {
    margin-top: 50px;
    width: 660px;
    .hyh {
      display: flex;
      margin-bottom: 53px;
      
      .y1 {
        font-weight: bold;
        font-size: 20px;
        color: #333333;
      }
      .y2 {
        margin-top: 12px;
        font-weight: 400;
        font-size: 14px;
        color: #656E7E;
      }
    }
  }

  .right_box {
  }
}
</style>
